import React from 'react';
import ReactApexChart from 'react-apexcharts';
import {mockStores} from "../../../../data/stores";


const generateRandomValue = () => Math.floor(Math.random() * 100) + 1000;

const generateDate = (startDate:any, daysToAdd:any) => {
  const date = new Date(startDate);
  date.setDate(date.getDate() + daysToAdd);
  return date.toISOString().split('T')[0];
};

const createSeriesData = () => {
  const series = [];
  const baseDate = new Date(2025, 2, 10);

  for (let i = 0; i < 5; i++) {
    const dataPoints = [];
    for (let j = 0; j < 30; j++) {
      dataPoints.push({
        x: generateDate(baseDate, j),
        y: generateRandomValue()
      });
    }
    series.push({
      name: mockStores[i].name,
      data: dataPoints
    });
  }

  return series;
};


const IrregularAreaCharts = ({dataColors}:any) => {
  const series = createSeriesData();

  const options = {
    chart: {
      type: 'area',
      height: 350,
      zoom: { enabled: false }
    },
    dataLabels: {
      enabled: false
    },
    markers: {
      size: 0,
    },
    stroke: {
      curve: 'smooth'
    },
    fill: {
      type: 'gradient',
      gradient: {
        shadeIntensity: 1,
        inverseColors: false,
        opacityFrom: 0.45,
        opacityTo: 0.05,
        stops: [20, 100, 100, 100]
      },
    },
    xaxis: {
      type: 'category',
      title: { text: 'Date' }
    },
    yaxis: {
      labels: {
        style: {
          colors: '#8e8da4',
        },
        offsetX: 0,
        formatter: function (val:any) {
          return (val);
        },
      },
      axisBorder: {
        show: false,
      },
      axisTicks: {
        show: false
      }
    },
    tooltip: {
      x: {
        format: 'yyyy-MM-dd'
      }
    },
    legend: {
      show: true
    }
  };

    return (
        <React.Fragment>
            
           <ReactApexChart
                dir='ltr'
                options={options}
                series={series}
                type="area"
                height="350"
                className="apex-charts"
            />
            
        </React.Fragment>
    );
};

export default IrregularAreaCharts;